import src from "IMAGE";
export default { src, width: 390, height: 390, blurWidth: 0, blurHeight: 0};
